export default {"src":"/_next/static/media/ric.fdbfddbd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};